import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@telespot/web-core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ts-chat-icon',
    templateUrl: './chat-icon.component.html',
    styleUrls: ['./chat-icon.component.scss'],
    standalone: false
})
export class ChatIconComponent implements OnInit, OnDestroy {
  public readonly currentUser$ = this.authService.currentUser$;
  public readonly currentOrganization$ = this.authService.currentOrganization$;

  public chatIconVisible = false;
  public llmFeatureEnabled = false;

  private _destroy$ = new Subject<void>();

  constructor(private authService: AuthService, private router: Router, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.currentOrganization$
      .pipe(
        takeUntil(this._destroy$),
        filter((organization) => !!organization)
      )
      .subscribe((organization) => {
        const llmChatFeature = organization.license?.features?.llm_chat;
        this.llmFeatureEnabled =
          (typeof llmChatFeature === 'object' ? llmChatFeature.enabled : llmChatFeature) ?? false;
        this.chatIconVisible = this.llmFeatureEnabled;
        this.changeDetectorRef.markForCheck();
      });

    this.router.events
      .pipe(
        takeUntil(this._destroy$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.chatIconVisible = this.llmFeatureEnabled && !this.router.url.includes('login');
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
  }
}
